'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _FormActions = require('./FormActions');

var _FormActions2 = _interopRequireDefault(_FormActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = (_temp2 = _class = function (_PureComponent) {
  _inherits(Form, _PureComponent);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      _this.checkValidity();
      var hasErrors = _this.hasErrors();
      if (hasErrors) {
        e.preventDefault();
        return;
      }

      var _this$props$onSubmit = _this.props.onSubmit,
          onSubmit = _this$props$onSubmit === undefined ? function () {} : _this$props$onSubmit;

      return onSubmit(e);
    }, _this.handleValidate = function (event) {
      var _this$props$onValidat = _this.props.onValidate,
          onValidate = _this$props$onValidat === undefined ? function () {} : _this$props$onValidat;
      var componentID = event.id,
          _event$target = event.target;
      _event$target = _event$target === undefined ? {} : _event$target;
      var targetID = _event$target.id;


      var id = targetID || componentID;

      if (!id) throw new Error('Form > Inputs must be assigned an \'id\' property');

      _this.setValidation(_defineProperty({}, id, event));
      onValidate(event);
    }, _this.hasErrors = function () {
      var errorProp = _this.props.error;

      return _this.hasControlledErrors() ? errorProp : _this.getErrors().length !== 0;
    }, _this.attach = function (node) {
      _this.inputs = Array.from(new Set([].concat(_toConsumableArray(_this.inputs), [node])));
    }, _this.detach = function (node) {
      _this.inputs = _this.inputs.filter(function (input) {
        return input !== node;
      });
    }, _this.validation = {}, _this.inputs = [], _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'createDefaultContext',
    value: function () {
      function createDefaultContext() // eslint-disable-line no-unused-vars
      {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _props$muiForm = props.muiForm,
            muiForm = _props$muiForm === undefined ? {
          onValidate: this.handleValidate,
          attach: this.attach,
          detach: this.detach,
          hasErrors: this.hasErrors
        } : _props$muiForm;

        return { muiForm: muiForm };
      }

      return createDefaultContext;
    }()
  }, {
    key: 'checkValidity',
    value: function () {
      function checkValidity() {
        var _props$onValidate = this.props.onValidate,
            onValidate = _props$onValidate === undefined ? function () {} : _props$onValidate;

        this.clearValidation();
        var errors = this.inputs.reduce(function (errors, input) {
          return [].concat(_toConsumableArray(errors), _toConsumableArray(input.checkValidity(undefined, undefined, true)));
        }, []);
        return errors;
      }

      return checkValidity;
    }()
  }, {
    key: 'hasControlledErrors',
    value: function () {
      function hasControlledErrors() {
        return !!this.props.error; // eslint-disable-line react/prop-types
      }

      return hasControlledErrors;
    }()
  }, {
    key: 'clearValidation',
    value: function () {
      function clearValidation() {
        this.validation = {};
      }

      return clearValidation;
    }()
  }, {
    key: 'setValidation',
    value: function () {
      function setValidation() {
        var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.validation = Object.assign({}, this.validation, next);
        var error = this.getErrors().length !== 0;
        if (this.state.error !== error) {
          this.setState({ error: error });
        }
      }

      return setValidation;
    }()
  }, {
    key: 'getErrors',
    value: function () {
      function getErrors() {
        var _this2 = this;

        return Object.keys(this.validation).filter(function (k) {
          return _this2.validation[k].hasErrors;
        }).reduce(function (o, k) {
          return [].concat(_toConsumableArray(o), [_this2.validation[k]]);
        }, []);
      }

      return getErrors;
    }()
  }, {
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        var muiForm = this.muiForm;

        return { muiForm: muiForm };
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var _createDefaultContext = this.createDefaultContext(this.props),
            muiForm = _createDefaultContext.muiForm;

        this.muiForm = muiForm;
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            Form = _props.formComponent,
            onSubmit = _props.onSubmit,
            onValidate = _props.onValidate,
            children = _props.children,
            confirmationActions = _props.confirmationActions,
            ConfirmationActions = _props.confirmationActionsComponent,
            confirmationActionsClassName = _props.confirmationActionsClassName,
            others = _objectWithoutProperties(_props, ['formComponent', 'onSubmit', 'onValidate', 'children', 'confirmationActions', 'confirmationActionsComponent', 'confirmationActionsClassName']);

        return _react2['default'].createElement(
          Form,
          _extends({}, others, { onSubmit: this.handleSubmit }),
          children,
          confirmationActions && _react2['default'].createElement(
            ConfirmationActions,
            { className: confirmationActionsClassName },
            confirmationActions
          )
        );
      }

      return render;
    }()
  }]);

  return Form;
}(_react.PureComponent), _class.propTypes = {
  /**
   * The content of the `Form`.
   */
  children: _PropTypes2['default'].node,
  /**
   * Nodes to be placed in the confirmation action container.
   */
  confirmationActions: _PropTypes2['default'].node,
  /**
   * Component to be used as the confirmation action node
   */
  confirmationActionsComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * The CSS class name of the confirmation action element.
   */
  confirmationActionsClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the form
   */
  formComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Node used for the child context
   */
  muiForm: _PropTypes2['default'].object,
  /**
   * Callback fired when form is submitted
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Callback fired when form is validated
   */
  onValidate: _PropTypes2['default'].func
}, _class.defaultProps = {
  confirmationActionsComponent: _FormActions2['default'],
  formComponent: 'form'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.childContextTypes = {
  muiForm: _PropTypes2['default'].object.isRequired
}, _temp2);
exports['default'] = Form;


Form.displayName = 'Form';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Form/Form.js
// module id = 1634
// module chunks = 32